<sl-select
    #multiSelect
    ngDefaultControl
    [name]="key"
    placeholder="Select an option"
    [clearable]="true" 
    [multiple]="true"
    [label]="props.label | htmlDecode"
    (sl-change)="onSelectionChange($event)"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [shoelaceReadonly]="props.readonly"
    [disabled]="props.disabled || false"
    [required]="props.required || false">
    <ng-container *ngFor="let option of getOptions(); let i = index">
        <sl-option [id]="id + '_' + i" [value]="option.value">{{ option.label }}</sl-option>
    </ng-container>
    <sl-icon class="large-clear-icon" slot="clear-icon" name="x-lg"></sl-icon>
</sl-select>